import styled from '@emotion/styled';
import { helperTypographyText, TypographyTextProps } from '../../../helpers';
import { exceptStyledProps } from '../../../utils';

// @ts-ignore
export const ParagraphEmotion = styled('p', exceptStyledProps('color'))<TypographyTextProps>`
  white-space: pre-line;
  ${props => helperTypographyText(props)};

  & + ${() => ParagraphEmotion} {
    margin-top: var(--typo-paragraph-mt, 1rem);
  }
`;
